import Vue from 'vue';
import Vuex from 'vuex';
import song from './modules/song';
import songsList from './modules/songsList';
import app from './modules/app';
import user from './modules/user';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        song,
        songsList,
        app,
        user,
    },
    strict: true, // debug,
});
